import { useState } from "react";
import { categories, ranking, seriesList } from "@/mocks/home";

export default function Showcase() {
  const [active, setActive] = useState("全部");
  const filtered =
    active === "全部"
      ? seriesList
      : seriesList.filter((s) => s.tags.includes(active));

  return (
    <section
      id="showcase"
      className="scroll-mt-20 bg-background-100 py-16 md:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-700">
              <i className="ri-fire-line"></i>
              本周热门韩漫
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              大家都在追的韩漫
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              高清画质、极速加载，按题材快速筛选你喜欢的韩漫作品，找到属于你的下一部心头好。
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {categories.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  active === c
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-2">
            {filtered.map((s) => (
              <article
                key={s.id}
                className="group flex gap-4 rounded-xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <div className="relative w-28 shrink-0 overflow-hidden rounded-lg md:w-32">
                  <img
                    src={s.cover}
                    alt={`${s.title} 韩漫封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <span className="absolute left-1.5 top-1.5 rounded-md bg-black/55 px-2 py-0.5 text-[10px] font-medium text-background-50">
                    {s.status}
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 flex-col py-1">
                  <h3 className="truncate font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                    {s.title}
                  </h3>
                  <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                    <span>{s.author}</span>
                    <span className="text-background-300">·</span>
                    <span className="flex items-center gap-1 text-accent-600">
                      <i className="ri-star-fill"></i>
                      {s.rating}
                    </span>
                  </div>
                  <div className="mt-1.5 flex flex-wrap gap-1.5">
                    {s.tags.map((t) => (
                      <span
                        key={t}
                        className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {s.description}
                  </p>
                  <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-book-2-line"></i>
                      {s.chapters}话
                    </span>
                    <span className="flex items-center gap-1 text-primary-600">
                      <i className="ri-refresh-line"></i>
                      {s.update}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <aside className="rounded-xl border border-background-200 bg-background-50 p-6">
            <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
              <i className="ri-medal-line text-accent-500"></i>
              人气榜单
            </h3>
            <ol className="mt-4 space-y-3">
              {ranking.map((r) => (
                <li key={r.rank} className="flex items-center gap-3 rounded-lg px-2 py-2 transition-colors hover:bg-background-100">
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                      r.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {r.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="truncate text-sm font-medium text-foreground-900">{r.title}</div>
                    <div className="text-xs text-foreground-500">{r.tag}</div>
                  </div>
                  <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
                    <i className="ri-heart-3-fill"></i>
                    {r.heat}
                  </span>
                </li>
              ))}
            </ol>
          </aside>
        </div>
      </div>
    </section>
  );
}